import { fireStore } from '../firebase';

export const getDocs = async () => {
  let docRef = fireStore.collection('categories');

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const addDoc = async ({data}) => {
  return await fireStore.collection('categories').doc(data.key).set(data);
}

export const updateDoc = async ({key, data}) => {
  return await fireStore.collection('categories').doc(key).update(data);
}
